export default {
  "content": "<path d=\"M23.259 15.65l-6 7a1 1 0 01-1.518 0l-3-3.5 1.518-1.3 2.241 2.614 5.241-6.114 1.518 1.3z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.5 4a3 3 0 013 3v5.5h-2v-2h-17V17a1 1 0 001 1h6v2h-6a3 3 0 01-3-3V7a3 3 0 013-3h15zm-15 2a1 1 0 00-1 1v1.5h17V7a1 1 0 00-1-1h-15z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};